import api from './api';
import { ProposalSection } from '../types/proposal';

export const createSection = async (propostaId: number, data: { titulo: string; conteudo?: string; prompt?: string; ordem: number; }) => {
  const response = await api.post(`/api/proposals/propostas/${propostaId}/secoes`, data);
  return response.data;
};

export const updateSection = async (secaoId: number, data: { titulo: string; conteudo: string; }) => {
  const response = await api.put(`/api/proposals/secoes/${secaoId}`, data);
  return response.data;
};

export const rewriteSection = async (secaoId: number, instruction: string) => {
  const response = await api.post(`/api/proposals/secoes/${secaoId}/rewrite`, { instruction });
  return response.data;
};

export const reorderSections = async (propostaId: number, secoes: number[]) => {
  const response = await api.put(`/api/proposals/propostas/${propostaId}/secoes/order`, { secoes });
  return response.data;
};

export const deleteSection = async (secaoId: number) => {
  const response = await api.delete(`/api/proposals/secoes/${secaoId}`);
  return response.data;
};

export const getSections = async (propostaId: number) => {
  const response = await api.get(`/api/proposals/propostas/${propostaId}/secoes`);
  return response.data;
};

export const getSectionsByToken = async (token: string) => {
  const response = await api.get(`/api/proposals/${token}/sections`);
  return response.data;
};

export const createSectionByToken = async (token: string, data: { titulo: string; conteudo?: string; prompt?: string; ordem: number; }) => {
  const response = await api.post(`/api/proposals/${token}/sections`, data);
  return response.data;
};

export const updateSectionByToken = async (token: string, sectionId: number, data: { titulo: string; conteudo: string; }) => {
  const response = await api.put(`/api/proposals/${token}/sections/${sectionId}`, data);
  return response.data;
};

export const rewriteSectionByToken = async (token: string, sectionId: number, instruction: string) => {
  const response = await api.post(`/api/proposals/${token}/sections/${sectionId}/rewrite`, { instruction });
  return response.data;
};

export const deleteSectionByToken = async (token: string, sectionId: number) => {
  const response = await api.delete(`/api/proposals/${token}/sections/${sectionId}`);
  return response.data;
}; 